<header class="z-30 shrink-0 border-b border-slate200 bg-white dark:border-slate700 dark:bg-slate800">
  <div class="flex h-[54px] items-center justify-between px-4 sm:px-6">

    <!-- Brand -->
    <div class="flex items-center gap-2.5">
      <div class="flex h-7 w-7 items-center justify-center rounded-lg bg-indigo600">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 9L12 2L21 9V20C21 20.5523 20.5523 21 20 21H15V15H9V21H4C3.44772 21 3 20.5523 3 20V9Z"/>
        </svg>
      </div>
      <span class="hidden text-[14px] font-semibold text-slate900 dark:text-white sm:block">Customer Portal</span>
    </div>

    <!-- Right actions -->
    <div #profileMenu class="relative flex items-center gap-2">

      <!-- Dark mode toggle -->
      <button
        type="button"
        (click)="darkMode.toggle()"
        class="flex h-8 w-8 items-center justify-center rounded-lg text-slate500 transition hover:bg-slate100 dark:text-slate400 dark:hover:bg-slate700"
        [attr.aria-label]="darkMode.isDark() ? 'Switch to light mode' : 'Switch to dark mode'"
      >
        @if (darkMode.isDark()) {
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="5"/>
            <line x1="12" y1="1" x2="12" y2="3"/>
            <line x1="12" y1="21" x2="12" y2="23"/>
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
            <line x1="1" y1="12" x2="3" y2="12"/>
            <line x1="21" y1="12" x2="23" y2="12"/>
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
          </svg>
        } @else {
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
          </svg>
        }
      </button>

      <!-- User avatar (dropdown trigger) -->
      <button
        type="button"
        (click)="toggleProfilePopup($event)"
        class="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-indigo600 text-xs font-bold text-white"
        aria-label="Open profile menu"
      >
        {{ user().initials }}
      </button>

      <!-- Profile dropdown -->
      @if (profilePopupOpen()) {
        <div
          class="absolute right-0 top-10 z-40 w-[260px] overflow-hidden rounded-xl border border-slate200 bg-white shadow-xl dark:border-slate700 dark:bg-slate800"
          (click)="$event.stopPropagation()"
        >
          <!-- User info header -->
          <div class="flex items-center gap-3 border-b border-slate200 p-4 dark:border-slate700">
            <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-indigo500 to-purple600 text-sm font-bold text-white">
              {{ user().initials }}
            </div>
            <div class="min-w-0 flex-1">
              <p class="truncate text-sm font-semibold text-slate900 dark:text-white">{{ user().name }}</p>
              <p class="truncate text-xs text-slate400 dark:text-slate500">{{ user().email }}</p>
            </div>
          </div>

          <!-- Actions -->
          <div class="p-2">
            <button
              type="button"
              class="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm text-slate600 transition hover:bg-slate50 dark:text-slate400 dark:hover:bg-slate700"
              (click)="openProfile()"
            >
              <app-icon-reusable [icon]="userProfileIcon" [size]="15"></app-icon-reusable>
              <span>My Profile</span>
            </button>
          </div>

          <!-- Sign out -->
          <div class="border-t border-slate200 p-2 dark:border-slate700">
            <button
              type="button"
              class="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium text-red500 transition hover:bg-red50 dark:text-red400 dark:hover:bg-red900/20"
              (click)="logout()"
            >
              <app-icon-reusable [icon]="signoutIcon" [size]="15" [useCurrentColor]="true"></app-icon-reusable>
              <span>Sign Out</span>
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</header>
